<template>
    <div class="add-tournament">
        <form action="" @submit="(e) => handleSubmit(e)" class="add-tournament__form">
            <div class="form__header">
                <button @click="hideOverlay()"><i class="fa-regular fa-xmark"></i></button>
                <h2>{{ $t('createTournament_AddTournament') }}</h2>
                <p>{{ $t('fillForm') }}</p>
            </div>
            <div class="form__body">
                <div class="input-container">
                    <label for="fullname">{{ $t('fullName') }}*</label>
                    <input v-model="fullname" type="text" name="fullname">
                </div>
                <div class="input-container">
                    <label for="email">{{ $t('email_AddTournament') }}*</label>
                    <input v-model="email" type="email" name="email">
                </div>
                <div class="input-container">
                    <label for="type">{{ $t('tournamentType') }}*</label>
                    <select v-model="tournamentType">
                        <option value="public">{{ $t('public') }}</option>
                        <option value="private">{{ $t('private') }}</option>
                    </select>
                </div>
                <div class="input-container">
                    <label for="description">{{ $t('description_AddTournament') }}*</label>
                    <textarea v-model="description" :placeholder="$t('moreContext')" type="text"
                        name="description" />
                </div>
            </div>
            <div class="form__actions">
                <button type="submit">{{ $t('send') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import tournament
    from '../../../repositories/tournament';
export default {

    props: {
        showAddTournament: Boolean,
        hideOverlay: Function,
        showMessage: Function,
        setLoading: Function
    },
    data: function () {
        return {
            tournamentType: "public",
            fullname: "",
            email: "",
            description: "",
        }
    },
    methods: {
        async handleSubmit(e) {
            e.preventDefault();
            this.setLoading();
            await tournament.sendTournamentRequest({
                name: this.fullname,
                email: this.email,
                tournamentVisibility: this.tournamentType.toUpperCase(),
                description: this.description
            }).then(() => {
                this.showMessage('success');
                
            }).catch(() => { 
                this.showMessage('error');
            });
            this.setLoading();
            this.resetForm();
            this.hideOverlay();
            
        },

        resetForm(){
            this.fullname= "";
            this.tournamentType = "public";
            this.email = "";
            this.description = "";
        }
    }
}
</script>

<style lang="scss">
.add-tournament {
    margin: auto;
    display: block;

    .add-tournament__form {
        padding: 30px 42px;
        display: flex;
        flex-direction: column;
        border-radius: 15px;
        font-family: "Avenir", sans-serif;
        background: var(--v-mainWhite-base);

        .form__header {
            display: flex;
            margin-bottom: 40px;
            flex-direction: column;

            button {
                width: 20px;
                height: 20px;
                border: none;
                outline: 0;
                align-self: flex-end;

                i {
                    color: var(--v-mainBlack-base);
                    font-size: 18px;
                }

                &:hover {
                    background: transparent;
                }
            }

            h6 {
                font-weight: bold;
                font-size: 40px;
                color: var(--v-mainGreen-base);
            }

            p {
                font-weight: normal;
                font-size: 16px;
                color: var(--v-mainBlack-base);
            }
        }

        .form__body {
            margin-bottom: 40px;

            .input-container {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;

                input {
                    background: #eee;
                    border-radius: 5px;
                    padding: 8px 16px;
                    border: none;
                    outline: 0;
                }

                label {
                    font-size: 14px;
                    color: var(--v-mainBlack-base);
                }

                textarea {
                    min-height: 110px;
                    padding: 8px 16px;
                    border-radius: 5px;
                    background: #eee;
                }

                select {
                    background: #eee;
                    padding: 8px 16px;
                    border-radius: 5px;
                }
            }
        }

        .form__actions {
            button {
                width: 100%;
                border-radius: 5px;
                color: var(--v-mainBlack-base);
                background: var(--v-mainGreen-base);
                ;
                border: none;
                outline: 0;
                text-align: center;
                height: 40px;
            }
        }
    }
}
</style>